import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  DxButtonComponent,
  DxCheckBoxComponent,
  DxLoadPanelComponent,
  DxLookupComponent,
  DxNumberBoxComponent,
  DxPopupComponent,
  DxTextAreaComponent,
  DxTextBoxComponent,
  DxValidationGroupComponent,
  DxValidatorComponent,
} from 'devextreme-angular';
import { Articoli } from 'src/app/models/articoli';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { ConvertError } from 'src/app/utils/gestione-errori';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';
import { GestArticoliBaseComponent } from '../../gest-articoli-base/gest-articoli-base.component';
import { DxiValidationRuleComponent } from 'devextreme-angular/ui/nested';
import { PrintBarCodeModel } from 'src/app/models/print-barcode-model';
import { PopupBarCodeComponent } from '../../popups/popup-barcode/popup-barcode.component';

@Component({
  selector: 'app-form-articolo',
  templateUrl: './form-articolo.component.html',
  styleUrls: ['./form-articolo.component.scss'],
  imports: [
    DxButtonComponent,
    DxTextBoxComponent,
    DxTextAreaComponent,
    DxNumberBoxComponent,
    DxLookupComponent,
    DxCheckBoxComponent,
    DxLoadPanelComponent,
    DxValidatorComponent,
    DxValidationGroupComponent,
    DxiValidationRuleComponent,
    DxPopupComponent,
    PopupBarCodeComponent
  ],
})
export class FormArticoloComponent
  extends GestArticoliBaseComponent
  implements OnInit, OnChanges
{
  private navigateService = inject(NavigatorService);
  private tipoArticoliService = inject(TipiArticoliService);
  private articoliService = inject(ArticoliService);
  @Input() articolo: Articoli;
  @Input() isNew: boolean;
  @Output() eventEmitterArticolo = new EventEmitter<Articoli>();

  popupInfoBarCode: boolean = false;
  printBarcodeModel: PrintBarCodeModel = new PrintBarCodeModel();

  valMod = false;
  articoloDB: Articoli;

  listTipoArticoli: any;
  loadPanelVisible: boolean = false;

  constructor() {
    super();
  }

  ngOnInit() {
    this.loadLookUp();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['articolo'] && changes['articolo'].currentValue) {
      this.articoloDB = this.cloneObj(this.articolo);
    }
  }

  loadLookUp() {
    //tipologie
    this.tipoArticoliService.getListTipiArticoliTemp().subscribe({
      next: (res) => {
        this.listTipoArticoli = {
          store: {
            type: 'array',
            data: res.sort((a, b) => (a.descrizione < b.descrizione ? -1 : 1)),
            key: 'id',
          },
          pageSize: 10,
          paginate: true,
        };
      },
      error: (error) => {
        ConvertError(error, 'Errore caricamento zone');
      },
    });
  }

  cloneObj(obj: any) {
    return Object.assign({}, obj);
  }

  valoreModificato() {
    const isEqual =
      JSON.stringify(this.articoloDB) === JSON.stringify(this.articolo);
    if (!isEqual && !this.isNew) {
      this.valMod = true;
    } else {
      this.valMod = false;
    }
  }

  SalvaArticolo = (e: any) => {
    this.loadPanelVisible = true;
    const result = e.validationGroup.validate();
    if (result.isValid) {
      if (!this.isNew) {
        //Modifica articolo
        this.articoliService.update(this.articolo.id, this.articolo).subscribe({
          next: () => {
            this.articoliService.listTemp(true).subscribe();
            this.valMod = false;
            this.loadPanelVisible = false;
            notificaMessaggio('Articolo aggiornato con successo', 'success');
            this.eventEmitterArticolo.emit(this.articolo);
          },
          error: (error) => {
            this.loadPanelVisible = false;
            ConvertError(error, 'Errore salvataggio articolo');
          },
        });
      } else {
        // Nuova articolo
        this.articoliService.insert(this.articolo).subscribe({
          next: (dati) => {
            this.articoliService.listTemp(true).subscribe();
            this.valMod = false;
            this.loadPanelVisible = false;
            notificaMessaggio(
              'Nuova articolo inserito con successo',
              'success',
            );
            this.navigateService.goToArticoliEdt(dati.id); //reindirizzo alla pagina di dettaglio di edt
          },
          error: (error) => {
            this.loadPanelVisible = false;
            ConvertError(error, 'Errore inserimento nuovo articolo');
          },
        });
      }
    } else {
      this.loadPanelVisible = false;
      notificaMessaggio(
        'Salvataggio non eseguito. Verifica di aver compilato correttamente i campi',
        'warning',
      );
    }
  };

  stampaEtichetta() {
    this.printBarcodeModel = new PrintBarCodeModel();
    this.printBarcodeModel.idsObject.push(this.articolo.id);
    this.popupInfoBarCode = true;
  }

  onPopupBarcodeEventEmitter(event){
    this.popupInfoBarCode = false;
    this.loadPanelVisible = true;
    this.printBarcodeModel.grande = event.grande;
    this.printBarcodeModel.numeroCopie = event.numeroCopie;
    this.articoliService.stampaEtichette(this.printBarcodeModel).subscribe({
      next: res=>{
        this.loadPanelVisible = false;
        const url = window.URL.createObjectURL(res);
        window.open(url);
      },
      error: err=>{
        this.loadPanelVisible = false;
        if(err?.error?.title){
          notificaMessaggio(err.error.title, "error");
        }
        else{
          notificaMessaggio("Errore stampa Etichetta", "error");
        }
      }
    })
  }
}
